import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Card, CardContent, Typography, Avatar, Chip, CircularProgress, Grid, Divider } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getOrderById } from "../../../Redux/Customers/Order/Action";

const OrderDetails = () => {
    const { orderId } = useParams();
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const orderDetails = useSelector((state) => state.order.order);
    const error = useSelector((state) => state.order.error);

    const getOrderDetails = async () => {
        setLoading(true);
        await dispatch(getOrderById(orderId));
        setLoading(false);
    };

    useEffect(() => {
        if (orderId) {
            getOrderDetails();
        }
    }, [orderId]);

    if (loading) return <Box display="flex" justifyContent="center" my={4}><CircularProgress /></Box>;

    if (error) return <Typography color="error" align="center">{error}</Typography>;

    if (!orderDetails) return <Typography align="center">No order details found.</Typography>;

    const { shippingAddress } = orderDetails;

    return (
        <Box mx={2} my={4}>
            <Card variant="outlined">
                <CardContent>
                    <Typography variant="h4" gutterBottom align="center">Order Details</Typography>
                    <Divider sx={{ mb: 2 }} />
                    <Box display="flex" flexDirection="column" alignItems="flex-start">
                        <Typography>Order ID: <span className="!font-normal">{orderDetails._id}</span></Typography>
                        <Typography>Status: <span className="!font-normal">{orderDetails.orderStatus}</span></Typography>
                        <Typography>Total Price: <span className="!font-normal">${orderDetails.totalPrice.toFixed(2)}</span></Typography>
                        <Typography>Shipping Address: <span className="!font-normal">
                            {`${shippingAddress.firstName} ${shippingAddress.lastName}, ${shippingAddress.streetAddress}, ${shippingAddress.city}, ${shippingAddress.state}, ${shippingAddress.zipCode}, Mobile: ${shippingAddress.mobile}`}
                        </span></Typography>
                    </Box>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h5" gutterBottom>Order Items</Typography>
                    {orderDetails?.orderItems?.length > 0 ? (
                        <Grid container spacing={2}>
                            {orderDetails.orderItems.map((item) => (
                                <Grid item xs={12} sm={6} md={5} key={item._id}>
                                    <Box display="flex" alignItems="center" p={2} border={1} borderColor="grey.300" borderRadius={2}>
                                        <Avatar src={item.product.imageUrl} alt={item.product.title} sx={{ width: 56, height: 56 }} />
                                        <Box ml={2} flexGrow={1}>
                                            <Typography variant="subtitle1" fontWeight="bold">{item.product.title}</Typography>
                                            <Chip label={item.product.brand} variant="outlined" />
                                            <Typography variant="body2" color="textSecondary" sx={{ marginTop: 1 }}>
                                                Quantity: {item.quantity}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    ) : (
                        <Typography>No items in this order.</Typography>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
};

export default OrderDetails;
